<template>
  <div class="progress">
    <div class="progressBox">
      <div
        v-for="(item, index) in steps"
        :key="index"
        class="progressItem"
        :class="{ progressActive: index === activeStep }"
        @click="handleStepClick(index)"
      >
        <span
          class="progressNum"
          :class="{ progressNumActive: index === activeStep }"
        >
          {{ index + 1 }}
        </span>
        <span>{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    activeStep: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    handleStepClick(index) {
      this.$emit("step-click", index);
    },
  },
};
</script>

<style scoped>
/* 重置浏览器默认样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.progressBox {
  display: flex;
}

.progressItem {
  width: 230px;
  padding: 0 20px;
  height: 50px;
  text-align: center;
  display: inline-block;
  line-height: 40px;
  background: rgba(21, 104, 235, 0.2);
  color: #1568eb;
  font-size: 14px;
  position: relative;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.progressNum {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 18px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 1px solid #1568eb;
  margin-right: 5px;
}

.progressItem:after {
  content: "";
  display: block;
  border-top: 25px solid transparent;
  border-bottom: 25px solid transparent;
  border-left: 25px solid rgba(21, 104, 235, 0.2);
  position: absolute;
  right: -25px;
  top: 0;
  z-index: 10;
}

.progressItem:before {
  content: "";
  display: block;
  border-top: 25px solid transparent;
  border-bottom: 25px solid transparent;
  border-left: 25px solid white;
  position: absolute;
  left: 0px;
  top: 0;
}

.progressItem:first-child::before {
  border: none;
}

.progressItem:last-child::after {
  border: none;
}

.progressActive {
  color: white;
  background: #1568eb;
}

.progressActive:after {
  border-left-color: #1568eb;
}

.progressNumActive {
  border: 1px solid white;
}
</style>
